import Api from "../../../app/apiRequest";
import BaseResponse from "../../../app/BaseResponse";
import CashAccountModel from "../models/CashAccountModel";

export interface GetCashAccountByIdParam {
    id: string,
}

export interface DeleteCashAccountByIdParam {
    id: string,
}

const CashAccountApi = {
    Save(param: CashAccountModel) {
        return Api.post<CashAccountModel, BaseResponse<CashAccountModel>>("/api/CashAccount/Save", param);
    },
    Delete(param: DeleteCashAccountByIdParam) {
        return Api.post<DeleteCashAccountByIdParam, BaseResponse<CashAccountModel>>("/api/CashAccount/Delete", param);
    },
    GetCashAccounts() {
        return Api.get<unknown, BaseResponse<CashAccountModel[]>>("/api/CashAccount/GetCashAccounts", null);
    },
};
export default CashAccountApi;